import { css, styled } from 'styled-components';

export const BaseDrawerWrapper = styled.div<{
  isOpen: boolean;
}>`
  ${({ isOpen, theme }) => css`
    position: fixed;
    transform: ${isOpen ? 'translateX(0%)' : 'translateX(100%)'};
    z-index: ${theme.zIndices.modal.dialog};
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: auto;
    transition-property: transform;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
  `}
`;

export const DrawerWrapper = styled(BaseDrawerWrapper)<{
  isOpen: boolean;
}>`
  ${({ theme }) => css`
    position: fixed;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    padding: 24px 0;
    z-index: ${theme.zIndices.modal.dialog};
    max-width: 300px;
    background: ${theme.colorsV2.white};
    box-shadow: ${theme.boxShadowV2.basic20};
  `}
`;

export const DrawerBody = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  overflow-y: auto;
`;

export const DrawerFooter = styled.div`
  flex: none;
  display: flex;
  justify-content: center;
  padding: 16px;
  margin-top: 5px;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.04);

  button {
    width: 100%;
    max-width: 300px;
  }
`;
